module.exports = __webpack_public_path__ + "img/agreement.74086c77.svg";